import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class ConfigurationService {
    static getPlatformConfiguration = (platformId) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        if (platformId === undefined) {
            platformId = appContext.getPlatformId();
        }

        return fetchAPI({
            token: undefined,
            url: `${config.PlatformConfiguration}platform-config/${platformId}/config.json`,
            method: 'GET',
        });
    };

    static getStackConfiguration = () => {
        return fetchAPI({
            token: undefined,
            url: '/stack.json',
            method: 'GET',
        });
    };

    static getPlatformStaticFile = (platformId, fileName) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();

        return fetchAPI({
            token: undefined,
            url: `${config.PlatformConfiguration}platform-config/${platformId}/${fileName}`,
            method: 'GET',
            parseJSON: false,
        });
    };

    static getStaticFileURL = (platformId, fileName) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();

        return `${config.PlatformConfiguration}platform-config/${platformId}/${fileName}`;
    };
}
export default ConfigurationService;